import React, { useState } from 'react';
import './ImportarPecas.css';
import api from '../../services/api';
import {
  limparProdutoSelecionado,
  produtoSelecionadoDaImportacao,
} from '../../utils/productContext';

function ImportarPecas() {
  const [codigoProduto, setCodigoProduto] = useState('');
  const [arquivo, setArquivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState(null);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);

  const [isProvisional, setIsProvisional] = useState(false);
  const [nomeProduto, setNomeProduto] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setArquivo(file);
      setErro(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isProvisional && !codigoProduto) {
      setErro('Preencha o código do produto');
      return;
    }
    if (!isProvisional && codigoProduto.replace(/\D/g, '').length !== 9) {
      setErro('O código do produto deve ter exatamente 9 dígitos');
      return;
    }
    if (isProvisional && !nomeProduto) {
      setErro('Preencha o nome do produto');
      return;
    }
    if (!arquivo) {
      setErro('Selecione um arquivo');
      return;
    }

    setLoading(true);
    setErro(null);
    setResultado(null);
    setProdutoSelecionado(limparProdutoSelecionado());

    try {
      const formData = new FormData();
      formData.append('file', arquivo);
      formData.append('is_provisional', isProvisional);

      if (isProvisional) {
        formData.append('nome_provisorio', nomeProduto);
      } else {
        formData.append('codigo_produto', codigoProduto);
        formData.append('nome_produto', `Produto ${codigoProduto}`);
      }

      const response = await api.post('/pecas/importar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const data = response.data;
      if (data.success) {
        const contextoProduto = produtoSelecionadoDaImportacao(data, {
          codigo: codigoProduto,
          nome: isProvisional ? nomeProduto : null,
          isProvisional,
        });
        setResultado(data);
        setProdutoSelecionado(contextoProduto);
        setCodigoProduto('');
        setNomeProduto('');
        setArquivo(null);
        document.getElementById('file-input').value = '';
      } else {
        setErro(data.detail || 'Erro ao importar peças');
      }
    } catch (error) {
      setErro(error.response?.data?.detail || 'Erro de conexão com o servidor');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h1 className="cw-page-title">Importar Lista de Peças</h1>
      <p className="cw-page-subtitle">Importe o Excel do CargaMaquina</p>
      <div className="importar-pecas">
        <div className="importar-container">
          <form onSubmit={handleSubmit} className="importar-form">

          {/* Toggle provisório */}
          <div className="form-group form-group-checkbox">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isProvisional}
                onChange={(e) => {
                  setIsProvisional(e.target.checked);
                  setErro(null);
                }}
              />
              Produto Não Cadastrado
            </label>
          </div>

          {/* Campos condicionais */}
          {!isProvisional ? (
            <div className="form-group">
              <label>Código do Produto * <small>(9 dígitos)</small></label>
              <input
                type="text"
                value={codigoProduto}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, '').slice(0, 9);
                  setCodigoProduto(val);
                  setErro(null);
                }}
                placeholder="Ex: 810015098"
                maxLength={9}
                style={codigoProduto && codigoProduto.length !== 9 ? { borderColor: '#e53e3e' } : {}}
              />
              {codigoProduto && codigoProduto.length !== 9 && (
                <small style={{ color: '#e53e3e' }}>{codigoProduto.length}/9 dígitos</small>
              )}
            </div>
          ) : (
            <div className="form-group">
              <label>Nome do Produto *</label>
              <input
                type="text"
                value={nomeProduto}
                onChange={(e) => setNomeProduto(e.target.value)}
                placeholder="Ex: Armário Cozinha"
                required
              />
            </div>
          )}

          <div className="form-group">
            <label>Arquivo Excel *</label>
            <div className="file-input-wrapper">
              <input
                type="file"
                id="file-input"
                accept=".xlsx,.xls,.csv"
                onChange={handleFileChange}
                required
              />
              <label htmlFor="file-input" className="file-label">
                {arquivo ? arquivo.name : 'Escolher arquivo Excel'}
              </label>
            </div>
          </div>

          {erro && (
            <div className="alerta erro">
              {erro}
            </div>
          )}

          {resultado && (
            <div className="alerta sucesso">
              {resultado.message}
              <br />
              <small>Produto: {produtoSelecionado?.codigo}</small>
            </div>
          )}

          <button
            type="submit"
            className="btn-importar"
            disabled={loading}
          >
            {loading ? 'Importando...' : 'Importar Peças'}
          </button>
        </form>

          <div className="dica">
            <strong>Dica:</strong> O arquivo deve conter as colunas: Peça, Material, C, L, Cod. Peça e Família
          </div>
        </div>
      </div>
    </>
  );
}

export default ImportarPecas;
